import { configureStore } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from 'redux'
import thunk from 'redux-thunk'
import authReducer from './authSlice'
import countryReducer from "./countryArray/countryArray"
import userReducer from "./userData/userData"
import serviceReducer from "./serviceRequest/serviceRequestRedux"
import financeReducer from "./financeData/financeData"


const reducers = combineReducers({
  auth: authReducer,
  country:countryReducer,
  user:userReducer,
  service:serviceReducer,
  finance: financeReducer
})

const persistConfig = {
  key: 'root',
  storage,
}

const persistedReducer = persistReducer(persistConfig, reducers)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
})
